import React from 'react';
import { INITIAL_COMPONENTS } from '../../config/componentLibrary.js';
import { Icons } from '../../components/Icon.jsx';

const getIcon = (label, section) => {
  if (section === 'Aldoo-RA') {
    switch (label) {
      case 'Image': return Icons.Image;
      case 'Button': return Icons.Button;
      case 'Input': return Icons.Input;
      case 'Checkbox': return Icons.Check;
      case 'Dropdown': return Icons.ChevronDown;
      case 'Menu': return Icons.Grid;
      case 'Data Table': return Icons.HorizontalLayout;
      case 'Panel': return Icons.Container;
      case 'Progress Bar': return Icons.HorizontalLayout;
      case 'Spinner': return Icons.Play;
      case 'Tabs': return Icons.Grid;
      case 'Toggle Switch': return Icons.Check;
      case 'Typography': return Icons.Typography;
      case 'Date Picker': return Icons.Database;
      case 'Date Range': return Icons.Database;
      case 'Drop Zone': return Icons.Upload;
      default: return Icons.Container;
    }
  }
  switch (label) {
    case 'Text': return Icons.Typography;
    case 'Image': return Icons.Image;
    case 'Button': return Icons.Button;
    case 'Input': return Icons.Input;
    default: return Icons.Container;
  }
};

const sections = [...new Set(INITIAL_COMPONENTS.map(c => c.section || 'Primitives'))];

const ComponentsTab = () => (
  <div className="p-4 space-y-6">
    {sections.map(section => {
      const components = INITIAL_COMPONENTS.filter(c => (c.section || 'Primitives') === section);
      const isAldoo = section === 'Aldoo-RA';
      return (
        <div key={section}>
          <h2 className="text-xs font-semibold text-gray-400 mb-3 uppercase tracking-wider flex items-center gap-2">
            {isAldoo && (
              <span className="inline-block w-2 h-2 rounded-full bg-blue-500" />
            )}
            {section}
          </h2>
          <div className="grid grid-cols-2 gap-2">
            {components.map((comp) => {
              const Icon = getIcon(comp.label, section);
              return (
                <div
                  key={`${section}-${comp.label}`}
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData('libraryLabel', comp.label);
                    e.dataTransfer.setData('librarySection', section);
                  }}
                  className={`flex flex-col items-center justify-center p-3 border shadow-sm rounded cursor-grab active:cursor-grabbing transition-all group ${
                    isAldoo
                      ? 'bg-blue-50 border-blue-200 hover:border-blue-500 hover:bg-blue-100'
                      : 'bg-white border-slate-200 hover:border-blue-400 hover:bg-blue-50'
                  }`}
                >
                  <Icon className={`mb-1.5 w-5 h-5 ${isAldoo ? 'text-blue-400 group-hover:text-blue-600' : 'text-gray-400 group-hover:text-blue-500'}`} />
                  <span className={`text-xs ${isAldoo ? 'text-blue-700 group-hover:text-blue-800' : 'text-gray-600 group-hover:text-blue-600'}`}>
                    {comp.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      );
    })}
  </div>
);

export default ComponentsTab;
